import { render, staticRenderFns } from "./PublishingCard.vue?vue&type=template&id=7273a30c&scoped=true&"
import script from "./PublishingCard.vue?vue&type=script&lang=js&"
export * from "./PublishingCard.vue?vue&type=script&lang=js&"
import style0 from "./PublishingCard.vue?vue&type=style&index=0&id=7273a30c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273a30c",
  null
  
)

export default component.exports